<template>
  <div class="zj-layout-main-content bgcolor scrollable" style="overflow: auto">
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="110px"
    >
      <zj-layout-container>
        <zj-layout-header>
          <div class="listtitle">车船基本信息详情</div>
        </zj-layout-header>
      </zj-layout-container>
      <!-- prop="ResourceName" -->
      <zj-layout-main>
        <el-form
          ref="form"
          :model="data"
          :rules="rules"
          label-width="16rem"
          style="width: 80%"
        >
          <el-row>
            <el-col :span="12">
              <el-form-item label="车船编号" prop="carNo">
                <el-input v-model="data.carNo" :disabled="!IsEdit"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="车船名称" prop="carName">
                <el-input v-model="data.carName" :disabled="!IsEdit"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="车船类型" prop="carType">
                <el-select
                  v-model="data.carType"
                  :disabled="!IsEdit"
                  placeholder="请选择"
                  style="width: 100%"
                >
                  <el-option
                    v-for="item in carTypeData"
                    :key="item.dictValue"
                    :label="item.dictName"
                    :value="item.dictValue"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="车牌号" prop="plateNo">
                <el-input v-model="data.plateNo" :disabled="!IsEdit"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="SIM卡号" prop="simNo">
                <el-input v-model="data.simNo" :disabled="!IsEdit"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="核定载客数" prop="passenerNum">
                <el-input
                  v-model="data.passenerNum"
                  :disabled="!IsEdit"
                  type="number"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="生产日期" prop="manufactureDate">
                <el-date-picker
                  placeholder="选择日期"
                  v-model="data.manufactureDate"
                  type="date"
                  format="yyyy-MM-dd"
                  style="width: 100%"
                  :disabled="!IsEdit"
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="保养日期" prop="maintainDate">
                <el-date-picker
                  placeholder="选择日期"
                  v-model="data.maintainDate"
                  type="date"
                  format="yyyy-MM-dd"
                  style="width: 100%"
                  :disabled="!IsEdit"
                ></el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="负责人" prop="contactsPerson">
                <el-input
                  v-model="data.contactsPerson"
                  :disabled="!IsEdit"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="负责人号码" prop="contactsMobile">
                <el-input
                  v-model="data.contactsMobile"
                  :disabled="!IsEdit"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="备注" prop="remarks">
                <el-input
                  v-model="data.remarks"
                  :disabled="!IsEdit"
                  type="textarea"
                  :autosize="{ minRows: 2 }"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </zj-layout-main>
      <el-form-item class="right" style="width: 134rem">
        <el-button @click="onBack()">返回</el-button>
        <el-button
          type="primary"
          @click="saveForm()"
          :disabled="!IsEdit"
          v-if="IsEdit"
          >保存</el-button
        >
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import MyApis from "../../../apis";
import ZJApp from "../../../../../app";
import { addCarShip, updateCarShip, getCarShipById } from "@/api/src/carship";

export default {
  name: "CarShipManagerInfo",
  controller: "UI",
  action: "CarShipManagerInfo",
  dicts: ["car_type"],
  data() {
    return {
      data: {
        carType: "",
        manufactureDate: new Date(),
        maintainDate: new Date(),
      },
      carTypeData:[],
      IsEdit: false,
      rules: {
        carNo: [{ required: true, message: "请输入车船编号", trigger: "blur" }],
        carName: [
          { required: true, message: "请输入车船名称", trigger: "blur" },
        ],
        carType: [
          { required: true, message: "请选择车船类型", trigger: "change" },
        ],
        passenerNum: [
          {
            required: false,
            message: "请输入有效的核定载客数",
            trigger: "blur",
            pattern: /^(0|[1-9]\d*)$/,
          },
        ],
      },
    };
  },
  created: function () {
    if (this.$route.query.InfoId) {
      this.search();
    }
    if (this.$route.query.type == "query") {
      this.IsEdit = false;
    } else {
      this.IsEdit = true;
    }
    this.getdictions()
  },
  watch: {
    $route: function () {
      if (this.$route.query.InfoId) {
        this.search();
      }
    },
  },
  methods: {
    getdictions(){
      this.$nextTick(() => {
        this.getDicts("car_type").then((res) => {
          console.log("res")
          console.log(res)
          this.carTypeData = res.rows;
        });
      });
    },
    // 查询详情
    search() {
      let InfoId = this.$route.query.InfoId;
      if (InfoId) {
        getCarShipById(InfoId)
          .then((r) => {
            this.data = r.data;
          })
          .catch((e) => {
            console.log(e);
            this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
          });
      }
    },
    //返回按钮
    onBack() {
      this.$router.go(-1); //返回上一层
    },
    //保存
    saveForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.saveData();
        } else {
          return false;
        }
      });
    },
    // 新增和编辑
    saveData() {
      if (this.$route.query.type == "edit") {
        //编辑
        let formAll = JSON.stringify(this.data);
        formAll = JSON.parse(formAll);
        updateCarShip(formAll)
          .then((r) => {
            let success = r.code == 200;
            this.$message({
              type: "success",
              message: success ? "保存成功！" : "保存失败！",
            });
            this.logInfo.ActionName = "车船基本信息修改";
            this.logInfo.LogMessage = success
              ? "车船基本信息修改成功"
              : "车船基本信息修改失败";
            this.logInfo.ModuleName = "车辆调度";
            this.logInfo.PageName = "车船基本信息详情";
            this.addOperationLog();
            this.$router.go(-1); //返回上一层
          })
          .catch((e) => {
            console.log(e);
            this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
          });
      } else {
        // 增加
        let formAll = this.data;
        formAll = JSON.stringify(formAll);
        formAll = JSON.parse(formAll);
        // return
        addCarShip(formAll)
          .then((r) => {
            let success = r.code == 200;
            this.$message({
              type: "success",
              message: success ? "保存成功！" : "保存失败！",
            });
            this.logInfo.ActionName = "车船基本信息添加";
            this.logInfo.LogMessage = success
              ? "车船基本信息添加成功"
              : "车船基本信息添加失败";
            this.logInfo.ModuleName = "车辆调度";
            this.logInfo.PageName = "车船基本信息详情";
            this.addOperationLog();
            this.$router.go(-1); //返回上一层
          })
          .catch((e) => {
            console.log(e);
            this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
          });
      }
    },
  },
};
</script>
